<div class="d-flex flex-column align-items-center">
  <figure>
    <img
      [alt]="'No ' + aspect"
      src="assets/images/icons/NoComputers.svg" />
  </figure>

  <span class="fw-bold">{{ title }}</span>

  <p class="pre-wrap text-center mt-2">{{ description }}</p>

  <div class="row">
    <div class="col-auto">
      <mbs-button
        [type]="'primary'"
        [icon]="'fa fa-plus text-lg'"
        [disabled]="loadingAspect"
        (click)="onAddDataButtonClick()">
        {{ addButtonText }}
      </mbs-button>
    </div>

    <div
      *ngIf="isReturnToGswAvailable"
      class="col-auto">
      <mbs-button
        [type]="'primary'"
        [attr.data-e2e]="elementSelectors.id.runGSW"
        [icon]="'fa fa-arrow-circle-right text-lg'"
        [disabled]="loading || loadingAspect"
        (click)="goToGettingStarted()">
        {{ runGSWButtonText }}
      </mbs-button>
    </div>
  </div>
</div>
